import {
  COST_SAVE_COST_BEGIN,
  COST_SAVE_COST_SUCCESS,
  COST_SAVE_COST_FAILURE,
  COST_SAVE_COST_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveCost(cost, action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COST_SAVE_COST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/costs';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        cost.cost = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }
      axios.post(URL, {
        cost:cost
      }, AXIOS_CONFIG())  
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            dispatch({
              type: COST_SAVE_COST_SUCCESS,
              data: res,
              action_model:action
            });
            
            resolve(res);
          }
          else if(res.data.success ===-1)
          {
            dispatch({
              type: COST_SAVE_COST_FAILURE,
              data: { error:-1},
              action_model:action
            });
            reject("Error!");
          }
          else
          {
            dispatch({
              type: COST_SAVE_COST_FAILURE,
              data: { error: "Internal error" },
              action_model:action
            });
            reject("Internal error!");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COST_SAVE_COST_FAILURE,
            data: { error: err },
            action_model:action
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveCostError() {
  return {
    type: COST_SAVE_COST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COST_SAVE_COST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveCostPending: true,
        saveCostError: null,
      };

    case COST_SAVE_COST_SUCCESS:
      let fragmentContent = "The Cost has been updated!";
      let fragmentTitle = "Update Cost";
      let paperTitle = "Update Cost";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        fragmentContent='The Cost has been created!'
        fragmentTitle='Create Cost'
        paperTitle='Create Cost'
      }
      // The request is success
      return {
        ...state,
        saveCostPending: false,
        savePending:false,
        saveCostError: null,
        costN:action.data && action.data.data?action.data.data.costN:null,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
      };

    case COST_SAVE_COST_FAILURE:
      // The request is failed
      let fragmentContentFail = "We found an error.";
      let fragmentTitleFail = "Update Cost";
      let paperTitleFail = "Update Cost ";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The cost has not been created!'
        fragmentTitleFail='Create Cost'
        paperTitleFail='Create Cost'
        
      }
      if(action.data && action.data.error === -1)
      {
        fragmentContentFail='You have reached the cost limit, please update your account'
      }

      return {
        ...state,
        saveCostPending: false,
        savePending:false,
        saveCostError: action.data.error,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
      };

    case COST_SAVE_COST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveCostError: null,
        
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/cost/redux/saveCost.js